var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.00016C0 0.631973 0.298477 0.333496 0.666667 0.333496H5.33333C5.70152 0.333496 6 0.631973 6 1.00016C6 1.36835 5.70152 1.66683 5.33333 1.66683H0.666667C0.298477 1.66683 0 1.36835 0 1.00016ZM9.5286 0.528758C9.78895 0.268409 10.2111 0.268409 10.4714 0.528758L12.4714 2.52876C12.7318 2.78911 12.7318 3.21122 12.4714 3.47157C12.2111 3.73192 11.7889 3.73192 11.5286 3.47157L10.6667 2.60964V9.00016C10.6667 9.36835 10.3682 9.66683 10 9.66683C9.63181 9.66683 9.33333 9.36835 9.33333 9.00016V2.60964L8.47141 3.47157C8.21106 3.73192 7.78895 3.73192 7.5286 3.47157C7.26825 3.21122 7.26825 2.78911 7.5286 2.52876L9.5286 0.528758ZM0 5.00016C0 4.63197 0.298477 4.3335 0.666667 4.3335H5.33333C5.70152 4.3335 6 4.63197 6 5.00016C6 5.36835 5.70152 5.66683 5.33333 5.66683H0.666667C0.298477 5.66683 0 5.36835 0 5.00016ZM0 9.00016C0 8.63197 0.298477 8.3335 0.666667 8.3335H6.66667C7.03486 8.3335 7.33333 8.63197 7.33333 9.00016C7.33333 9.36835 7.03486 9.66683 6.66667 9.66683H0.666667C0.298477 9.66683 0 9.36835 0 9.00016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscending);
export default __webpack_public_path__ + "static/media/ascending.1cd86ba9e3c81234531d6effe98bcb04.svg";
export { ForwardRef as ReactComponent };